import { CButton } from "@coreui/react";
import style from "./CustomButton.module.css";

function CustomButton(props) {
  return props.icon ? (
    <CButton
      variant={props.variant}
      onClick={props.onClick}
      style={props.style}
      className={props.className}
    >
      {props.icon}
      &nbsp;
      {props.text}
    </CButton>
  ) : (
    <CButton
      variant={props.variant}
      onClick={props.onClick}
      style={props.style}
      className={props.className}
    >
      {props.text}
    </CButton>
  );
}

export default CustomButton;
